import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Switch,
  Typography,
} from "@mui/material";
import { BucketTwrFormula } from "constants/index";
import { twrFormulaLabel } from "./summaryFigures";

const OPTION_LABEL_SX = {
  mr: 0,
  "& .MuiFormControlLabel-label": {
    typography: "body2",
  },
};

/**
 * The report's formula settings: which time-weighted return formula the
 * cards show, and the option-pairing formula the next Calculate runs with.
 * Rendered inside the report's Settings dialog (StrategyReportSettings).
 *
 * Disabled for the whole of a run, so neither can change under one.
 */
const SummaryFormulaSettings = ({
  disabled,
  twrFormula,
  onTwrFormulaChange,
  optionPairingV2,
  onOptionPairingChange,
  periodStart,
}: {
  disabled: boolean;
  twrFormula: BucketTwrFormula;
  onTwrFormulaChange: (formula: BucketTwrFormula) => void;
  optionPairingV2: boolean;
  onOptionPairingChange: (enabled: boolean) => void;
  periodStart: string | undefined;
}) => (
  <>
    <FormControl disabled={disabled}>
      <FormLabel id="twr-formula-label" sx={{ mb: 1, typography: "subtitle2" }}>
        Time-Weighted Return
      </FormLabel>
      <RadioGroup
        aria-labelledby="twr-formula-label"
        value={twrFormula}
        onChange={(event) =>
          onTwrFormulaChange(event.target.value as BucketTwrFormula)
        }
      >
        {Object.values(BucketTwrFormula).map((formula) => (
          <FormControlLabel
            key={formula}
            value={formula}
            control={<Radio size="small" />}
            label={twrFormulaLabel(formula, periodStart)}
            sx={OPTION_LABEL_SX}
          />
        ))}
      </RadioGroup>
    </FormControl>
    <FormControl disabled={disabled} sx={{ mt: 2, display: "block" }}>
      <FormLabel
        id="option-pairing-label"
        sx={{ mb: 0.5, typography: "subtitle2", display: "block" }}
      >
        Option Pairing
      </FormLabel>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={optionPairingV2}
            onChange={(event) => onOptionPairingChange(event.target.checked)}
            inputProps={{ "aria-labelledby": "option-pairing-label" }}
          />
        }
        label={
          optionPairingV2 ? "Fixed pairing (PUT expiry)" : "Previous formula"
        }
        sx={OPTION_LABEL_SX}
      />
      <Typography variant="caption" color="text.secondary" display="block">
        Applies on the next Calculate.
      </Typography>
    </FormControl>
  </>
);

export default SummaryFormulaSettings;
